import toast from 'react-hot-toast';

export function showSuccess(msg: string) {
  toast.success(msg, {
    duration: 3000,
    style: {
      background: '#10B981',
      color: '#fff',
      fontWeight: 500,
    },
  });
}

export function showError(msg: string) {
  toast.error(msg, {
    duration: 5000,
    style: {
      background: '#EF4444',
      color: '#fff',
      fontWeight: 500,
    },
  });
}

export function showInfo(msg: string) {
  toast(msg, {
    duration: 3000,
    style: {
      background: '#af7964',
      color: '#fff',
      fontWeight: 500,
    },
  });
}
